import { render, staticRenderFns } from "./CountrySettingDetail.vue?vue&type=template&id=9e50dbc2&scoped=true"
import script from "./CountrySettingDetail.vue?vue&type=script&lang=js"
export * from "./CountrySettingDetail.vue?vue&type=script&lang=js"
import style0 from "./CountrySettingDetail.vue?vue&type=style&index=0&id=9e50dbc2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e50dbc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e50dbc2')) {
      api.createRecord('9e50dbc2', component.options)
    } else {
      api.reload('9e50dbc2', component.options)
    }
    module.hot.accept("./CountrySettingDetail.vue?vue&type=template&id=9e50dbc2&scoped=true", function () {
      api.rerender('9e50dbc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/countrysetting/CountrySettingDetail.vue"
export default component.exports